{
  "lists": {
    "name_required": "Veuillez saisir un nom de liste",
    "create_list": "Créer une liste",
    "name": "Nom",
    "enable_duplicate_contacts": "Activer les contacts en double"
  },
  "company_list": {
    "shared_company_list": "liste d'entreprises partagée",
    "personal_company_list": "liste d'entreprises personnelle",
    "project_company_list": "liste d'entreprises de projet",
    "list_memberships": "Adhésions aux listes",
    "import_companies": "Importer des entreprises",
    "add_company": "Ajouter une entreprise",
    "add_to_list": "Ajouter à la liste",
    "edit_company_type": "Modifier le type d'entreprise",
    "bulk_edit": "Modification en lot",
    "remove": "Supprimer",
    "list": "Liste",
    "company": "Entreprise",
    "add_company_to_list": "Ajouter une entreprise à la liste",
    "bulk_edit_custom_fields": "Modification en lot des champs personnalisés",
    "edit_custom_fields": "Modifier les champs personnalisés",
    "please_select_company": "Veuillez sélectionner une entreprise à ajouter à cette liste",
    "please_choose_list": "Veuillez choisir une liste",
    "which_company_placeholder": "Quelle entreprise voulez-vous ajouter à cette liste",
    "action_cannot_be_undone": "Cette action ne peut pas être annulée",
    "delete_tab_confirmation": "Êtes-vous sûr de vouloir supprimer cet onglet ?",
    "company_removed_from_list": "L'entreprise sera supprimée de cette liste.",
    "remove_company_confirmation": "Êtes-vous sûr de vouloir supprimer l'entreprise de cette liste ?",
    "remove_company_aria_label": "supprimer l'entreprise de cette liste",
    "loading_companies": "chargement des entreprises",
    "more_companies_contact_support": "Il y a plus d'entreprises que celles affichées. Veuillez contacter le support NEXL."
  },
  "my_lists": {
    "page": {
      "create_list": "Créer une liste",
      "search_placeholder": "Rechercher le nom de la liste",
      "lists_header": "Listes"
    },
    "navigation": {
      "other_lists": "Autres listes"
    },
    "empty_states": {
      "no_shared_list": "Aucune liste partagée",
      "your_list_is_empty": "Votre liste est vide",
      "no_lists_found": "Aucune liste trouvée",
      "no_search_results": "Nous n'avons trouvé aucune liste correspondant à votre recherche. Essayez d'utiliser des mots-clés différents ou créez une nouvelle liste"
    },
    "actions": {
      "add_to_list": "Ajouter à la liste",
      "list_actions": "Actions de liste",
      "rename_list": "Renommer la liste",
      "share_list": "Partager la liste"
    },
    "forms": {
      "list_name": "Nom de la liste",
      "list_name_required": "Veuillez saisir un nom de liste",
      "invite": "Inviter",
      "invitee_required": "Veuillez choisir au moins un invité",
      "enable_duplicate_contacts": "Autoriser les contacts en double",
      "duplicate_contacts_tooltip": "L'activation des contacts en double permet plusieurs entrées dans les formulaires. Cependant, veuillez noter que l'importation et l'exportation de données peuvent ne pas fonctionner correctement."
    },
    "confirmations": {
      "archive_list_title": "Archiver la liste ?",
      "archive_list_content": "Êtes-vous sûr de vouloir archiver cette liste ? Elle sera supprimée de la liste.",
      "remove_user_title": "Êtes-vous sûr de vouloir supprimer cet utilisateur ?",
      "remove_user_content": "Cliquez sur confirmer pour supprimer"
    },
    "share": {
      "invite_tab": "Inviter",
      "access_tab": "Accès",
      "owner": "Propriétaire",
      "success_message": "Votre liste a été partagée avec succès. Nous informerons les destinataires.",
      "loading_users": "Chargement des utilisateurs"
    },
    "scopes": {
      "all": {
        "name": "Rechercher des listes",
        "description": "Recherchez une liste à laquelle vous avez accès ou sélectionnez parmi vos listes récemment consultées."
      },
      "created": {
        "name": "Créé par moi",
        "description": "Voici vos éléments récemment créés. Utilisez la recherche pour en trouver d'autres et restez organisé en suivant votre travail."
      },
      "shared": {
        "name": "Partagé avec moi",
        "description": "Recherchez pour trouver une liste ou sélectionnez parmi une de vos listes récentes partagées avec vous."
      },
      "workspace": {
        "name": "Listes d'espace de travail",
        "description": ""
      },
      "app": {
        "name": "Listes d'applications",
        "description": ""
      },
      "marketing": {
        "name": "Listes marketing",
        "description": ""
      }
    },
    "types": {
      "contact_list": "Créer une liste de contacts pour votre projet",
      "company_list": "Créer une liste d'entreprises pour votre projet",
      "generic_list": "Créer une liste personnalisée pour soutenir votre projet"
    },
    "empty_descriptions": {
      "shared": "Il semble que personne n'ait encore partagé de listes avec vous. Quand quelqu'un partage une liste, elle apparaîtra ici.",
      "marketing": "Commencez à créer votre liste sur Marketing pour les voir ici.",
      "app": "Commencez à créer votre liste sur Apps pour les voir ici.",
      "workspace": "Commencez à créer votre liste sur Workspace pour les voir ici.",
      "default": "Commencez à créer votre liste pour les voir ici."
    }
  },
  "company_list_grid": {
    "add_company": "Ajouter une entreprise",
    "add_to_list": "Ajouter à la liste",
    "edit_company_type": "Modifier le type d'entreprise",
    "bulk_edit": "Modification en lot",
    "remove": "Supprimer",
    "import_companies": "Importer des entreprises"
  },
  "removed_history": {
    "title": "Historique des suppressions",
    "empty_state": {
      "title": "Aucun contact supprimé",
      "description": "Aucun contact n'a encore été supprimé de cette liste. Une fois les contacts supprimés, ils apparaîtront ici."
    },
    "table": {
      "selected_count": "{{count}} sélectionné(s)",
      "headers": {
        "contact": "Contact",
        "company": "Entreprise",
        "removed_date": "Date de suppression",
        "removed_by": "Supprimé par"
      }
    },
    "actions": {
      "add_to_list": "Ajouter à la liste",
      "go_back_tooltip": "retourner à {{listName}}"
    }
  },
  "e_marketing_integration": {
    "settings": {
      "title": "Paramètres eMarketing",
      "sync_to_tools": "Synchroniser avec les outils eMarketing",
      "sync_to_tools_caption": "Chaque fois que vous synchronisez avec un outil eMarketing, une nouvelle liste sera créée dans leur application. Vous pouvez choisir quels champs mapper, en vous assurant que les bonnes données sont incluses."
    },
    "sync": {
      "title": "Synchroniser les contacts",
      "save_and_sync": "Sauvegarder et synchroniser",
      "connector_name": "Nom du connecteur",
      "e_marketing_list_name": "Nom de la liste eMarketing",
      "e_marketing_list_name_caption": "Si une liste avec le même nom existe dans l'outil eMarketing, elle sera écrasée.",
      "type_connector_name": "Tapez le nom du connecteur",
      "select_connector": "Sélectionner le connecteur",
      "syncing_tooltip": "La synchronisation des contacts avec l'outil eMarketing est en cours.",
      "syncing_status": "Synchronisation..."
    },
    "status": {
      "out_of_sync_title": "Liste non synchronisée.",
      "sync_now": "Synchroniser maintenant",
      "sync_now_description": "pour mettre à jour vos données.",
      "sync_complete_title": "Synchronisation terminée :",
      "sync_complete_description": "Votre liste de contacts a été synchronisée avec",
      "sync_failed_title": "Échec de la synchronisation :",
      "sync_failed_description": "Cela peut être dû à des problèmes de connexion ou à des paramètres incorrects. Ouvrez",
      "e_marketing_setup": "configuration eMarketing",
      "retry_description": "pour réessayer."
    },
    "disconnect": {
      "title": "Supprimer la connexion ?",
      "description": "Êtes-vous sûr de vouloir supprimer cette connexion ? Cette action supprimera l'intégration et toutes les synchronisations en cours seront arrêtées. Cette action ne peut pas être annulée.",
      "aria_label": "Supprimer la connexion",
      "button_title": "Supprimer la connexion"
    },
    "field_mapping": {
      "title": "Champs à mapper",
      "nexl_fields": "Champs Nexl",
      "concep_fields": "Champs Concep",
      "add_map_field": "Ajouter un champ de mappage",
      "select_nexl_field": "Sélectionner le champ Nexl",
      "select_remote_field": "Sélectionner le champ distant",
      "remove_field_mapping": "Supprimer le mappage de champ {{index}}"
    }
  }
}
